export const _INSTRUCTOR_ERIC_POGUE = { 
	name:'Eric Pogue', 
	title:'Associate Professor',
	officeHours:'Wednesday 9:30 AM to 11 AM CST by appointment',
	office:'AS-124-A', 
	appointmentRequests:'Appointments can be requested via email',
	lewisPhone:'(815) 836-5015',
	lewisEmail:'epogue@lewisu.edu',
	mobilePhone:'(563) 209-7280' 
}